import Vue from 'vue';
import Report from "@/components/reports/Report";
import * as registry from "@/components/reports/reportRegistry";
import {ReportRegister} from "@/components/reports/reportRegistry";

export default Vue.extend({
  name: 'Reports',
  components: {
    Report
  },
  computed: {
    authorizedReports(): ReportRegister[] {
      return registry.reportRegisters.filter(report => this.$store.getters['user/hasRole'](report.roles));
    }
  },
  data() {
    return {
      registry: registry,
      reportPath: ''
    }
  },
  created() {
    if (this.$route.path.includes("/reports/")){
      this.reportPath = this.$route.path.replace("/reports/", "");
    }
  },
  methods: {
    reportChange() {
      this.$router.push(`/reports/${this.reportPath}`)
    }
  }
});



// WEBPACK FOOTER //
// ./src/components/reports/Reports.ts